import { useCallback } from 'react'
import useGlobalState from './useGlobalState'

function getTimeString() {
    const opts = { timeZone: 'Europe/Berlin' }
    const date = new Date()
    const time =
        date.toLocaleTimeString('de-DE', opts).slice(0, 8) +
        '.' +
        date.getMilliseconds().toString().padStart(3, '0')
    return time
}

export type Log = (msg: string) => void

export default function useLog(): [Log, () => void] {
    const clearLog = useGlobalState((state) => state.clearLog)
    const addToLog = useGlobalState((state) => state.addToLog)

    const log = useCallback(
        (msg: string) => {
            addToLog(`[${getTimeString()}] ${msg}`)
        },
        [addToLog]
    )
    return [log, clearLog]
}
